import React, { FC } from 'react';
import styled from '@emotion/styled';

type Props = {
  borderRadius?: number;
  className?: string;
  fill: string;
  color: string;
};

export const createSvgIcon = (Path: FC<Partial<Props>>, viewBox?: string, title?: string) => {
  return ({ className, fill, borderRadius, ...rest }: Props) => (
    <SVG className={className} viewBox={viewBox} fill={fill} {...rest}>
      {title && <title>{title}</title>}
      <Path fill={fill} borderRadius={borderRadius} />
    </SVG>
  );
};

const SVG = styled('svg')`
  width: 1em;
  height: 1em;
`;
